import type { SelectProps } from 'antd';
import { Select as AntdSelect, RefSelectProps } from 'antd';
import * as React from 'react';

type SelectComponent = React.ForwardRefExoticComponent<
  SelectProps & React.RefAttributes<RefSelectProps>
> & {
  Option: typeof AntdSelect.Option;
};

const Select = React.forwardRef<RefSelectProps, SelectProps>((props, ref) => {
  const { virtual = false, ...otherProps } = props;
  if (
    virtual &&
    !otherProps.dropdownStyle?.width &&
    !otherProps.popupMatchSelectWidth
  ) {
    if (process.env.NODE_ENV === 'development') {
      console.warn(
        `Il componente <Select> con virtualizzazione DEVE avere una larghezza definita _oppure_ popupMatchSelectWidth=true, altrimenti le performance sono compromesse.`,
      );
    }

    otherProps.popupMatchSelectWidth = true;
  }
  return <AntdSelect {...otherProps} ref={ref} virtual={virtual} />;
}) as SelectComponent;
Select.displayName = 'Select';

Select.Option = AntdSelect.Option;

export { Select, type SelectProps };
